// Partitions
import * as _ from "lodash"
import { Schema } from "js-data";
import * as PASchema from "./PAdbSchema";
import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default

} from "./PAdbSchema";


// PEA Portfolio
export const WB_Event_Portfolio = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_Portfolio', // optional
    description: 'Schema for WB_Evt_Portfolio records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_SALESORG_ID": {
            "type": "number"
        },
        "PORTFOLIO_ID": {
            "type": "string",
            "length": 50
        },
        "PORTFOLIO_NAME": {
            "type": "string",
            "length": 256
        },
        "PORTFOLIO_COMMENTS": {
            "type": "string",
            "length": 1333
        },
        "OVERLAP_HANDLING": {
            "type": "string",
            "length": 256
        },
        "CANNIBALIZATION_POLICY": {
            "type": "string",
            "length": 256
        },
        "METRIC_SET": {
            "type": "string",
            "length": 256
        },
        "WB_CUSTH_ID": {
            "type": "number"
        },
        "WB_PRDH_ID": {
            "type": "number"
        },
        "WB_PERIODH_ID": {
            "type": "number"
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number"
        },
        "WB_DATAMART_ID": {
            "type": "number"
        },
        "DEFAULT_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        },
        "INTEGRATION_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    }
});
export const WB_Event_Portfolio_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Event_Portfolio_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolioRs'
        },
        [PASchema.esWB_Event_Portfolio_Customer_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Customers'
        },
        [PASchema.esWB_Event_Portfolio_Product_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Products'
        },
        [PASchema.esWB_Event_Portfolio_Period_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Periods'
        },
        [PASchema.esWB_Event_Portfolio_Tag_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Tags'
        },
        [PASchema.esWB_Event_Portfolio_EventType_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventTypes'
        },
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'LinkedAnalyses'
        }
    },
    belongsTo: {
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: "UserCreatedBy"
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: "SalesOrg" },
        [PASchema.esWB_DataMart]: { foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: "DataMart" }
    }
};

export const WB_Event_Portfolio_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioR', // optional
    description: 'Schema for WB_Evt_PortfolioR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "ANALYSIS_TYPE": {
            "type": "string",
            "length": 50
        },
        "INTEGRATION_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        }
    }
});
export const WB_Event_Portfolio_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Event]: {
            foreignKey: 'WB_EVT_ID',
            foreignKeyImmutable: true,
            localField: 'Event'
        }
    }
};

//Portfolio Customer Relationship
export const WB_Event_Portfolio_Customer_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioCR', // optional
    description: 'Schema for WB_Evt_PortfolioCR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOCR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_CUST_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    }
});
export const WB_Event_Portfolio_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        }
    }
};

//Portfolio Period Relationship
export const WB_Event_Portfolio_Period_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioTR', // optional
    description: 'Schema for WB_Evt_PortfolioTR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOTR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_PERIOD_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    }
});
export const WB_Event_Portfolio_Period_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Period]: {
            foreignKey: 'WB_PERIOD_ID',
            foreignKeyImmutable: true,
            localField: 'Period'
        }
    }
};

//Portfolio Product Relationship
export const WB_Event_Portfolio_Product_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioPR', // optional
    description: 'Schema for WB_Evt_PortfolioPR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOPR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    }
});
export const WB_Event_Portfolio_Product_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        }
    }
};


//Portfolio Tag Relationship
export const WB_Event_Portfolio_Tag_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioTGR', // optional
    description: 'Schema for WB_Evt_PortfolioTGR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOTGR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_TAG_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_Event_Portfolio_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Tag]: {
            foreignKey: 'WB_TAG_ID',
            foreignKeyImmutable: true,
            localField: 'Tag'
        }
    }
};

//Portfolio EventType Relationship
export const WB_Event_Portfolio_EventType_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioETR', // optional
    description: 'Schema for WB_Evt_PortfolioETR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOETR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_EVTTYPE_ID": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_Event_Portfolio_EventType_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Event_Type]: {
            foreignKey: 'WB_EVTTYPE_ID',
            foreignKeyImmutable: true,
            localField: 'EventType'
        }
    }
};

//Portfolio Linked Analysis
export const WB_Event_Portfolio_LinkedAnalysis = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioLA', // optional
    description: 'Schema for WB_Evt_PortfolioLA records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOLA_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "LINKED_ANALYSIS_NAME": {
            "type": "string",
            "length": 256
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    }
});
export const WB_Event_Portfolio_LinkedAnalysis_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        }
    },
    hasMany: {
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIOLA_ID',
            foreignKeyImmutable: true,
            localField: 'Events'
        }
    }
};

//Portfolio Linked Analysis
export const WB_Event_Portfolio_LinkedAnalysis_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioLAR', // optional
    description: 'Schema for WB_Evt_PortfolioLAR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOLAR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIOLA_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    }
});
export const WB_Event_Portfolio_LinkedAnalysis_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: {
            foreignKey: 'WB_EVT_PORTFOLIOLA_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolioLA'
        }
    }
};

//FC Override
export const WB_FC_Override = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd', // optional
    description: 'Schema for WB_Ovrd records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number"
        },
        "WB_PLAN_ID": {
            "type": "number"
        },
        "CNS_START_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CNS_END_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "WB_EVTS_ID": {
            "type": "number"
        },
        "OVRD_ID": {
            "type": "string",
            "length": 50
        },
        "OVRD_STATUS": {
            "type": "string",
            "length": 50
        },
        "OVRD_TYPE": {
            "type": "string",
            "length": 10
        },
        "BASE_OVRD": {
            "type": "number"
        },
        "EDLP_OVRD": {
            "type": "number"
        },
        "MERCH_INCR_OVRD": {
            "type": "number"
        },
        "DISPLAY_INCR_OVRD": {
            "type": "number"
        },
        "TOTAL_OVRD": {
            "type": "number"
        },
        "DEACTIVATE_IND": {
            "type": "string",
            "length": 1
        },
        "TABLE_OPTIONS": {
            "type": "string",
            "default": "",
            "length": 2500
        },
        "PERSPECTIVE_OPTIONS": {
            "type": "string",
            "default": "",
            "length": 2500
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Plan]: {
            foreignKey: 'WB_PLAN_ID',
            foreignKeyImmutable: true,
            localField: 'Plan'
        },
        [PASchema.esWB_Event]: {
            foreignKey: 'WB_EVT_ID',
            foreignKeyImmutable: true,
            localField: 'Event'
        },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'User'
        },
        [PASchema.esWB_Event_Spend]: {
            foreignKey: 'WB_EVTS_ID',
            foreignKeyImmutable: true,
            localField: 'Tactic'
        }
    },
    hasMany: {
        [PASchema.esWB_FC_Override_Event_Volume]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideVolumes'
        },
        [PASchema.esWB_FC_Override_Event_Date]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideDates'
        },
        [PASchema.esWB_FC_Override_Event_Spend]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideSpends'
        },
        [PASchema.esWB_FC_Override_Event_Spend_Redistribution]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideRedistributions'
        },
        [PASchema.esWB_FC_Override_Customer]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'Customers'
        },
        [PASchema.esWB_FC_Override_Product]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'Products'
        },
        [PASchema.esWB_FC_Override_Consumption]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'Consumption'
        },
        [PASchema.esWB_FC_Override_Event_Product]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideProducts'
        },
        [PASchema.esWB_FC_Override_Event_Source_Customer]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideCustomers'
        }
    },
    hasOne: {
        [PASchema.esWB_FC_Override_Event_Merge]:
            {
                foreignKey: 'WB_OVRD_ID',
                foreignKeyImmutable:
                    true,
                localField:
                    'FCOverrideMerge'
            }
    }
};

//FC Override Date
export const WB_FC_Override_Event_Date = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_EvtDt', // optional
    description: 'Schema for WB_Ovrd_EvtDt records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_EVTDT_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "WB_EVTS_ID": {
            "type": "number"
        },
        "INSTORE_START_DT_OVRD": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "INSTORE_END_DT_OVRD": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "SHIPMENT_START_DT_OVRD": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "SHIPMENT_END_DT_OVRD": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Date_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_Event]: {
            foreignKey: 'WB_EVT_ID',
            foreignKeyImmutable: true,
            localField: 'Event'
        },
        [PASchema.esWB_Event_Spend]: {
            foreignKey: 'WB_EVTS_ID',
            foreignKeyImmutable: true,
            localField: 'FCDateSpend'
        }
    }
};

//FC Override Spend
export const WB_FC_Override_Event_Spend = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_EvtS', // optional
    description: 'Schema for WB_Ovrd_EvtS records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_EVTS_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "WB_EVTS_ID": {
            "type": "number"
        },
        "WB_EVTSPG_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "WB_EVTSPRD_ID": {
            "type": "number"
        },
        "WB_PROD_ID": {
            "type": "number"
        },
        "RATE_OVRD": {
            "type": "number"
        },
        "REDEMPTION_PCNT_OVRD": {
            "type": "number"
        },
        "SPEND_OVRD": {
            "type": "number"
        },
        "PIF_IND_OVRD": {
            "type": "string",
            "length": 1
        },
        "OVRD_ACTUALSPEND_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Spend_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'FCSpendPPG'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'FCSpendPROD'
        }
    }
};

//FC Override Volume
export const WB_FC_Override_Event_Volume = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_EvtVol', // optional
    description: 'Schema for WB_Ovrd_EvtVol records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_EVTVOL_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "BASE_OVRD": {
            "type": "number"
        },
        "EDLP_OVRD": {
            "type": "number"
        },
        "MERCH_INCR_OVRD": {
            "type": "number"
        },
        "DISPLAY_INCR_OVRD": {
            "type": "number"
        },
        "TOTAL_OVRD": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Volume_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'FCPPG'
        }
    }
};


//FC Override Log
export const WB_FC_Override_Log = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_Log', // optional
    description: 'Schema for WB_Ovrd_Log records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_LOG_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "WB_EVTS_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "OPERATION_ID": {
            "type": "string",
            "length": 50
        },
        "SOURCE_ID": {
            "type": "string",
            "length": 50
        },
        "MESSAGE_TYPE": {
            "type": "string",
            "length": 50
        },
        "LOG_MESSAGE": {
            "type": "string",
            "length": 500
        },
        "OVRD_STATUS_NEXT": {
            "type": "string",
            "length": 50
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Log_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'User'
        }
    }
};

//FC Override Merge
export const WB_FC_Override_Event_Merge = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_EvtMerge', // optional
    description: 'Schema for WB_Ovrd_EvtMerge records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_EVTMERGE_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_PLAN_ID": {
            "type": "number"
        },
        "EVENT_ID": {
            "type": "string",
            "length": 50
        },
        "EVENT_NAME": {
            "type": "string",
            "length": 256
        },
        "EVENT_TYPE_ID": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Merge_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_Plan]: {
            foreignKey: 'WB_PLAN_ID',
            foreignKeyImmutable: true,
            localField: 'Plan'
        }
    },
    hasMany: {
        [PASchema.esWB_FC_Override_Event_MergeR]: {
            foreignKey: 'WB_OVRD_EVTMERGE_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideMergeRs'
        }
    }
};

//FC Override Merge R
export const WB_FC_Override_Event_MergeR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_EvtMergeR', // optional
    description: 'Schema for WB_Ovrd_EvtMergeR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_EVTMERGER_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_EVTMERGE_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_MergeR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override_Event_Merge]: {
            foreignKey: 'WB_OVRD_EVTMERGE_ID',
            foreignKeyImmutable: true,
            localField: 'FCMerge'
        },
        [PASchema.esWB_Event]: {
            foreignKey: 'WB_EVT_ID',
            foreignKeyImmutable: true,
            localField: 'Event'
        }
    }
};

//FC Override Spend Cost
export const WB_FC_Override_Event_Source_Customer = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_EvtSCst', // optional
    description: 'Schema for WB_Ovrd_EvtSCst records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_EVTSCST_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "WB_CUST_ID": {
            "type": "number"
        },
        "SOURCE_TYPE": {
            "type": "string",
            "length": 15
        },
        "OPERATION_IND": {
            "type": "string"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Source_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'FCCustomer'
        }
    }
};


//FC Override Spend Redistribution
export const WB_FC_Override_Event_Spend_Redistribution = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_SpndRdst', // optional
    description: 'Schema for WB_Ovrd_SpndRdst records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_SPNDRDST_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_EVTS_ID": {
            "type": "number"
        },
        "REDIST_SPEND": {
            "type": "number"
        },
        "WB_OVRD_ID_PRNT": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string"
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Spend_Redistribution_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_Event_Spend]: {
            foreignKey: 'WB_EVTS_ID',
            foreignKeyImmutable: true,
            localField: 'FCRedistSpend'
        }
    },
    hasMany: {
        [PASchema.esWB_FC_Override_Event_Spend_RedistributionR]: {
            foreignKey: 'WB_OVRD_SPNDRDST_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideTacticPPGs'
        }
    }
};

//FC Override Spend Redistribution PPG
export const WB_FC_Override_Event_Spend_RedistributionR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_SpndRdstR', // optional
    description: 'Schema for WB_Ovrd_SpndRdstR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_SPNDRDSTR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_SPNDRDST_ID": {
            "type": "number"
        },
        "WB_EVTSPG_ID": {
            "type": "number"
        },
        "REDIST_SPEND": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string"
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Spend_RedistributionR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override_Event_Spend_Redistribution]: {
            foreignKey: 'WB_OVRD_SPNDRDST_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverrideRedistribution'
        },
        [PASchema.esWB_Event_Spend_PrdGrp]: {
            foreignKey: 'WB_EVTSPG_ID',
            foreignKeyImmutable: true,
            localField: 'FCRedistSpendPPG'
        }
    }
};

//FC Override Product
export const WB_FC_Override_Event_Product = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_EvtPrd', // optional
    description: 'Schema for WB_Ovrd_EvtS records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_EVTPRD_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "WB_EVTS_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "OPERATION_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Event_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'FCOverride'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'FCPPG'
        },
        [PASchema.esWB_Event]: {
            foreignKey: 'WB_EVT_ID',
            foreignKeyImmutable: true,
            localField: 'FCEvent'
        },
        [PASchema.esWB_Event_Spend]: {
            foreignKey: 'WB_EVTS_ID',
            foreignKeyImmutable: true,
            localField: 'ProductSpend'
        }
    }
};


// FC Override Customer Scope, Product Scope, Consumption
export const WB_FC_Override_Customer = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_CR', // optional
    description: 'Schema for WB_Ovrd_CR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_CR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_CUST_ID": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'Override'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        }
    }
};

export const WB_FC_Override_Product = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_PR', // optional
    description: 'Schema for WB_Ovrd_PR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_PR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'Override'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        }
    }
};

export const WB_FC_Override_Consumption = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Ovrd_Cns', // optional
    description: 'Schema for WB_Ovrd_Cns records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_OVRD_CNS_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_OVRD_ID": {
            "type": "number"
        },
        "WB_CUST_ID_SOURCE": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "START_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "END_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "BASE_OVRD": {
            "type": "number"
        },
        "EDLP_OVRD": {
            "type": "number"
        },
        "MERCH_INCR_OVRD": {
            "type": "number"
        },
        "DISPLAY_INCR_OVRD": {
            "type": "number"
        },
        "WT_UOM_PER_UNIT": {
            "type": "number"
        },
        "STAT_UOM_PER_UNIT": {
            "type": "number"
        },
        "RTLSLS_UOM_PER_UNIT": {
            "type": "number"
        },
        "RTLSLS_UOM_PER_BASE_UNIT": {
            "type": "number"
        },
        "RTLSLS_UOM_PER_INCR_UNIT": {
            "type": "number"
        },
        "SYND_BASE_PRICE": {
            "type": "number"
        },
        "SYND_PROMOTED_PRICE": {
            "type": "number"
        },
        "SYND_COVERAGE_FACTOR": {
            "type": "number"
        },
        "SYND_CNS_BASE_UNITS": {
            "type": "number"
        },
        "SYND_CNS_BASE_WT": {
            "type": "number"
        },
        "SYND_CNS_BASE_STAT": {
            "type": "number"
        },
        "SYND_CNS_BASE_RTLSLS": {
            "type": "number"
        },
        "SYND_CNS_PROMOBASE_UNITS": {
            "type": "number"
        },
        "SYND_CNS_PROMOBASE_WT": {
            "type": "number"
        },
        "SYND_CNS_PROMOBASE_STAT": {
            "type": "number"
        },
        "SYND_CNS_PROMOBASE_RTLSLS": {
            "type": "number"
        },
        "SYND_CNS_INCR_UNITS": {
            "type": "number"
        },
        "SYND_CNS_INCR_STAT": {
            "type": "number"
        },
        "SYND_CNS_INCR_WT": {
            "type": "number"
        },
        "SYND_CNS_INCR_RTLSLS": {
            "type": "number"
        },
        "SYND_CNS_DISP_INCR_UNITS": {
            "type": "number"
        },
        "SYND_CNS_DISP_INCR_STAT": {
            "type": "number"
        },
        "SYND_CNS_DISP_INCR_WT": {
            "type": "number"
        },
        "SYND_CNS_DISP_INCR_RTLSLS": {
            "type": "number"
        },
        "SYND_CNS_TOTAL_UNITS": {
            "type": "number"
        },
        "SYND_CNS_TOTAL_STAT": {
            "type": "number"
        },
        "SYND_CNS_TOTAL_WT": {
            "type": "number"
        },
        "SYND_CNS_TOTAL_RTLSLS": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_FC_Override_Consumption_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_FC_Override]: {
            foreignKey: 'WB_OVRD_ID',
            foreignKeyImmutable: true,
            localField: 'Override'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID_SOURCE',
            foreignKeyImmutable: true,
            localField: 'Customer'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        }
    }
};


// Dictionaries
//-- Schemas
_.defaults(dctSchemaByEntitySet,
    {
        [PASchema.esWB_Event_Portfolio]: WB_Event_Portfolio,
        [PASchema.esWB_Event_Portfolio_Relationship]: WB_Event_Portfolio_Relationship,
        [PASchema.esWB_Event_Portfolio_Customer_Relationship]: WB_Event_Portfolio_Customer_Relationship,
        [PASchema.esWB_Event_Portfolio_Product_Relationship]: WB_Event_Portfolio_Product_Relationship,
        [PASchema.esWB_Event_Portfolio_Period_Relationship]: WB_Event_Portfolio_Period_Relationship,
        [PASchema.esWB_Event_Portfolio_Tag_Relationship]: WB_Event_Portfolio_Tag_Relationship,
        [PASchema.esWB_Event_Portfolio_EventType_Relationship]: WB_Event_Portfolio_EventType_Relationship,
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: WB_Event_Portfolio_LinkedAnalysis,
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: WB_Event_Portfolio_LinkedAnalysis_Relationship,
        [PASchema.esWB_FC_Override]: WB_FC_Override,
        [PASchema.esWB_FC_Override_Log]: WB_FC_Override_Log,
        [PASchema.esWB_FC_Override_Event_Volume]: WB_FC_Override_Event_Volume,
        [PASchema.esWB_FC_Override_Event_Spend]: WB_FC_Override_Event_Spend,
        [PASchema.esWB_FC_Override_Event_Date]: WB_FC_Override_Event_Date,
        [PASchema.esWB_FC_Override_Event_Merge]: WB_FC_Override_Event_Merge,
        [PASchema.esWB_FC_Override_Event_MergeR]: WB_FC_Override_Event_MergeR,
        [PASchema.esWB_FC_Override_Event_Source_Customer]: WB_FC_Override_Event_Source_Customer,
        [PASchema.esWB_FC_Override_Event_Spend_Redistribution]: WB_FC_Override_Event_Spend_Redistribution,
        [PASchema.esWB_FC_Override_Event_Spend_RedistributionR]: WB_FC_Override_Event_Spend_RedistributionR,
        [PASchema.esWB_FC_Override_Event_Product]: WB_FC_Override_Event_Product,
        [PASchema.esWB_FC_Override_Customer]: WB_FC_Override_Customer,
        [PASchema.esWB_FC_Override_Product]: WB_FC_Override_Product,
        [PASchema.esWB_FC_Override_Consumption]: WB_FC_Override_Consumption
    });

//-- Table Names
_.defaults(dctTableNameByEntitySet,
    {
        [PASchema.esWB_Event_Portfolio]: "/AZR/WB_EVT_PORTFOLIO",
        [PASchema.esWB_Event_Portfolio_Relationship]: "/AZR/WB_EVT_PORTFOLIOR",
        [PASchema.esWB_Event_Portfolio_Customer_Relationship]: "/AZR/WB_EVT_PORTFOLIOCR",
        [PASchema.esWB_Event_Portfolio_Period_Relationship]: "/AZR/WB_EVT_PORTFOLIOTR",
        [PASchema.esWB_Event_Portfolio_Product_Relationship]: "/AZR/WB_EVT_PORTFOLIOPR",
        [PASchema.esWB_Event_Portfolio_Tag_Relationship]: "/AZR/WB_EVT_PORTFOLIOTGR",
        [PASchema.esWB_Event_Portfolio_EventType_Relationship]: "/AZR/WB_EVT_PORTFOLIOETR",
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: "/AZR/WB_EVT_PORTFOLIOLA",
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: "/AZR/WB_EVT_PORTFOLIOLAR",
        [PASchema.esWB_FC_Override]: "/AZR/WB_OVRD",
        [PASchema.esWB_FC_Override_Log]: "/AZR/WB_OVRD_LOG",
        [PASchema.esWB_FC_Override_Event_Volume]: "/AZR/WB_OVRD_EVTVOL",
        [PASchema.esWB_FC_Override_Event_Spend]: "/AZR/WB_OVRD_EVTS",
        [PASchema.esWB_FC_Override_Event_Date]: "/AZR/WB_OVRD_EVTDT",
        [PASchema.esWB_FC_Override_Event_Merge]: "/AZR/WB_OVRD_EVTMERGE",
        [PASchema.esWB_FC_Override_Event_MergeR]: "/AZR/WB_OVRD_EVTMERGER",
        [PASchema.esWB_FC_Override_Event_Source_Customer]: "/AZR/WB_OVRD_EVTSCST",
        [PASchema.esWB_FC_Override_Event_Spend_Redistribution]: "/AZR/WB_OVRD_SPNDRDST",
        [PASchema.esWB_FC_Override_Event_Spend_RedistributionR]: "/AZR/WB_OVRD_SPNDRDSTR",
        [PASchema.esWB_FC_Override_Event_Product]: "/AZR/WB_OVRD_EVTPRD",
        [PASchema.esWB_FC_Override_Customer]: "/AZR/WB_OVRD_CR",
        [PASchema.esWB_FC_Override_Product]: "/AZR/WB_OVRD_PR",
        [PASchema.esWB_FC_Override_Consumption]: "/AZR/WB_OVRD_CNS"
    })

//-- Logical Key
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_Event_Portfolio]: [],
    [PASchema.esWB_Event_Portfolio_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Customer_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Product_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Period_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Tag_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_EventType_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: [],
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: [],
    [PASchema.esWB_FC_Override]: [],
    [PASchema.esWB_FC_Override_Log]: [],
    [PASchema.esWB_FC_Override_Event_Volume]: [],
    [PASchema.esWB_FC_Override_Event_Spend]: [],
    [PASchema.esWB_FC_Override_Event_Date]: [],
    [PASchema.esWB_FC_Override_Event_Merge]: [],
    [PASchema.esWB_FC_Override_Event_MergeR]: [],
    [PASchema.esWB_FC_Override_Event_Source_Customer]: [],
    [PASchema.esWB_FC_Override_Event_Spend_Redistribution]: [],
    [PASchema.esWB_FC_Override_Event_Spend_RedistributionR]: [],
    [PASchema.esWB_FC_Override_Event_Product]: [],
    [PASchema.esWB_FC_Override_Customer]: [],
    [PASchema.esWB_FC_Override_Product]: [],
    [PASchema.esWB_FC_Override_Consumption]: []

})

//-- Other Foreign Keys without jsData  Relationship
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_Event_Portfolio]: {},
    [PASchema.esWB_Event_Portfolio_Relationship]: {},
    [PASchema.esWB_FC_Override]: {},
    [PASchema.esWB_FC_Override_Log]: {},
    [PASchema.esWB_FC_Override_Event_Volume]: {},
    [PASchema.esWB_FC_Override_Event_Spend]: {},
    [PASchema.esWB_FC_Override_Event_Date]: {},
    [PASchema.esWB_FC_Override_Event_Merge]: {},
    [PASchema.esWB_FC_Override_Event_MergeR]: {},
    [PASchema.esWB_FC_Override_Event_Source_Customer]: {},
    [PASchema.esWB_FC_Override_Event_Spend_Redistribution]: {},
    [PASchema.esWB_FC_Override_Event_Spend_RedistributionR]: {},
    [PASchema.esWB_FC_Override_Event_Product]: {},
    [PASchema.esWB_FC_Override_Customer]: {},
    [PASchema.esWB_FC_Override_Product]: {},
    [PASchema.esWB_FC_Override_Consumption]: {}

})

//-- Key Pools
_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_Event_Portfolio]: { sequence_name: "/AZR/WB_EVT_PORTFOLIO_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_Relationship]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_Customer_Relationship]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOCR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_Period_Relationship]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOTR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_Product_Relationship]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_Tag_Relationship]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOTGR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_EventType_Relationship]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOETR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOLA_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: { sequence_name: "/AZR/WB_EVT_PORTFOLIOLAR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override]: { sequence_name: "/AZR/WB_OVRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Log]: { sequence_name: "/AZR/WB_OVRD_LOG_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Volume]: { sequence_name: "/AZR/WB_OVRD_EVTVOL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Spend]: { sequence_name: "/AZR/WB_OVRD_EVTS_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Date]: { sequence_name: "/AZR/WB_OVRD_EVTDT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Merge]: { sequence_name: "/AZR/WB_OVRD_EVTMERGE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_MergeR]: { sequence_name: "/AZR/WB_OVRD_EVTMERGER_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Source_Customer]: { sequence_name: "/AZR/WB_OVRD_EVTSCST_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Spend_Redistribution]: { sequence_name: "/AZR/WB_OVRD_SPNDRDSTR_SEQ ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Spend_RedistributionR]: { sequence_name: "/AZR/WB_OVRD_SPNDRDSTRR_SEQ ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Event_Product]: { sequence_name: "/AZR/WB_OVRD_EVTPRD_SEQ ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Customer]: { sequence_name: "/AZR/WB_OVRD_CR_SEQ ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Product]: { sequence_name: "/AZR/WB_OVRD_PR_SEQ ", ...KeyGenSpecs_default },
    [PASchema.esWB_FC_Override_Consumption]: { sequence_name: "/AZR/WB_OVRD_CNS_SEQ ", ...KeyGenSpecs_default }

})

// Add Section for Custom Columns if needed
